import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import AccessDeniedImg from 'assets/images/access_denied.webp';
import ChatPanel from 'components/common/ChatPanel';
import Conversation from 'components/common/Conversation';
import { PrimaryBtn } from 'components/UI/Buttons';
import useQuery from 'hooks/useQuery';
import { useNavigate } from 'react-router-dom';
import { useGetPublicClientMessagesQuery } from 'services/api/public-access';
import { NAVY } from 'styles/tokens';

const PublicChat = () => {
  const query = useQuery();
  const clientId = query.get('clientId');
  const token = query.get('token');
  if (!clientId || !token)
    return (
      <div>
        <p>Client ID or token not found</p>
      </div>
    );
  const navigate = useNavigate();
  const { data, error } = useGetPublicClientMessagesQuery({
    clientId: Number(clientId),
    token: String(token),
  });
  if (error) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          mt: 2,
        }}
      >
        <img src={AccessDeniedImg} alt="error" width="500" />
        <Typography
          variant="h4"
          sx={{
            mt: 4,
          }}
        >
          El link al que estás tratando de acceder no es válido. Puede que haya vencido.
        </Typography>
        <PrimaryBtn sx={{ mt: 8 }} variant="contained" onClick={() => navigate(`/clients/${clientId}`)}>
          Ver detalles del cliente
        </PrimaryBtn>
      </Box>
    );
  }
  const clientName = data ? `${data.client.firstName} ${data.client.lastName}`.trim() : undefined;
  return (
    <ChatPanel>
      <ChatPanel.Header
        title="Chat del Cliente"
        subtitle={clientName || undefined}
        rightAction={
          <IconButton href={`/clients/${clientId}`} sx={{ color: NAVY }}>
            <OpenInNewIcon />
          </IconButton>
        }
      />
      <ChatPanel.Body>
        <Conversation conversation={data?.messages || []} isFilteredConversation fullHeight />
      </ChatPanel.Body>
    </ChatPanel>
  );
};

export default PublicChat;
